import { useEffect, useRef, useState } from 'react';
import { Eye, EyeOff, Lock, ArrowRight } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, encryptPassword, projectLogo } from '../CommonComponents/CustomHooks';
import Loader from '../CommonComponents/Loader';
import { InputBox } from '../CommonComponents/InputBox';
import { CommonApiData } from '../CommonComponents/EnvConfig';

export default function ForgotPasswordSlide() {
    const inputrefs = useRef({});
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState({
        newPassword: false,
        confirmPassword: false,
    });

    let url = window.location.search;
    const queryString = new URLSearchParams(url);
    const UserCode = queryString.get('UserCode');
    const RPToken = queryString.get('Token');

    const [loginData, setLoginData] = useState({
        confirmPassword: '',
        userCode: CommonApiData().loginUserCode, 
        newPassword: '',
    });
    const handleInput = (field, value) => {
        setLoginData(prev => ({ ...prev, [field]: value }));
    };

    const handleTogglePassword = (field) => {
        setShowPassword(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        const bodyData = {
            userCode: loginData.userCode,
            newPassword: encryptPassword(loginData.newPassword),
            confirmPassword: encryptPassword(loginData.confirmPassword),
            RPToken,
        };

        try {
            let res = await ApiCall(`/api/UserLogin/ResetPassword`, bodyData);
            if (res.status === 'SUCCESS') {
                NotificationSound(res.status, res.message, res.focus, inputrefs);
                setTimeout(() => {
                    setIsLoading(false);
                    navigate('/');
                }, 700);
            } else {
                setIsLoading(false);
                NotificationSound(res.status, res.message, res.focus, inputrefs);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error', error);
            NotificationSound('ERROR', 'Unexpected error. Please try again.');
        }
    };

    useEffect(() => {
        if (UserCode) {
            setLoginData(prev => ({
                ...prev,
                userCode: UserCode
            }));
        }
    }, [UserCode]);


    useEffect(() => {
        document.title = 'Forgot Password';
            inputrefs.current["txtPassword"].focus();
    }, []);

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-blue-500 via-white to-red-400 flex items-center justify-center p-8 relative overflow-hidden">
                <div className="absolute top-10 left-10 w-48 h-48 bg-[#00adef]/10 rounded-full blur-3xl"></div>
                <div className="absolute bottom-5 left-32 w-64 h-64 bg-[#00adef]/15 rounded-full"></div>
                <div className="absolute top-20 right-20 w-56 h-56 bg-[#ec1f24]/10 rounded-full"></div>

                {/* Glowing circles */}
                {/*<div className="absolute inset-0 overflow-hidden pointer-events-none">*/}
                {/*    <div className="absolute top-20 left-10 w-72 h-72 bg-blueled rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>*/}
                {/*    <div className="absolute bottom-20 right-10 w-72 h-72 bg-[#3e7c98] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>*/}
                {/*</div>*/}

                {/* Reset Password Card */}
                <div className="relative w-full max-w-md">
                    <div className="bg-white rounded-3xl shadow-2xl p-8 backdrop-blur-sm border border-gray-100">

                        {/* Logo */}
                        <div className="text-center mb-8">
                            <div className="flex justify-center items-center">
                                {/*<img src={`./images/${projectLogo()}`} alt="logo" />*/}
                                <img src={"./main-logo.png"} alt="logo" className='h-20 mb-4' />
                            </div>
                            <h2 className="mt-1 text-lg font-bold text-gray-800">Forgot Password</h2>
                            {/*<h2 className="mt-1 text-lg font-bold text-gray-800">Reset Password</h2>*/}
                            {/*<p className="text-gray-500 mt-1">Enter your new password</p>*/}
                        </div>

                        {/* Form */}
                        <div className="space-y-6">

                            {/* USERCODE */}
                            <InputBox
                                id="txtUserCode"
                                type="text"
                                divclassname="col-md-12"
                                label="User Code"
                                placeholder="Enter User Code"
                                value={loginData.userCode}
                                disabled={true}
                                inputrefs={inputrefs}
                            />



                            <InputBox
                                id="txtPassword"
                                divclassname="col-md-12"
                                type={showPassword.newPassword ? "text" : "password"}
                                label="New Password"
                                placeholder="Enter New password"
                                value={loginData.newPassword}
                                inputrefs={inputrefs}
                                leftIcon={<Lock className="h-5 w-5 text-gray-400" />}
                                showPassword={showPassword.newPassword}
                                togglePassword={() => handleTogglePassword("newPassword")}
                                onChange={(e) => handleInput("newPassword", e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        inputrefs.current["txtConfirmPassword"].focus();
                                    }
                                }}
                            />


                            {/* Confirm Password */}
                            <InputBox
                                id="txtConfirmPassword"
                                type={showPassword.confirmPassword ? "text" : "password"}
                                label="Confirm Password"
                                divclassname="col-md-12"
                                placeholder="Enter Confirm password"
                                value={loginData.confirmPassword}
                                inputrefs={inputrefs}
                                leftIcon={<Lock className="h-5 w-5 text-gray-400" />}
                                showPassword={showPassword.confirmPassword}
                                togglePassword={() => handleTogglePassword("confirmPassword")}
                                onChange={(e) => handleInput("confirmPassword", e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        inputrefs.current["btnSub"].focus();
                                    }
                                }}
                            />


                            {/* Submit Button */}
                            <button
                                id="btnSub"
                                ref={(el) => (inputrefs.current["btnSub"] = el)}
                                onClick={handleSubmit}
                                className="w-full bg-[#00adef] hover:bg-[#0096d1] text-white py-3 px-4 rounded-xl font-semibold flex items-center justify-center group shadow-md transition"
                            >
                                Submit
                                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                            </button>

                            {/* Back to Login */}
                            <p className="text-center text-sm text-gray-600 mt-4">
                                <Link to="/" className="font-medium text-blueled hover:text-[#3e7c98]">
                                    Back to Login
                                </Link>
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            {isLoading && <Loader />}
        </>
    );
}
